import { render, staticRenderFns } from "./TeachGroupDialog.vue?vue&type=template&id=c916dcc2&"
import script from "./TeachGroupDialog.vue?vue&type=script&lang=js&"
export * from "./TeachGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports